import { render } from "./EventCreate.vue?vue&type=template&id=da0deb36&scoped=true"
import script from "./EventCreate.vue?vue&type=script&lang=js"
export * from "./EventCreate.vue?vue&type=script&lang=js"

import "./EventCreate.vue?vue&type=style&index=0&id=da0deb36&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-da0deb36"

export default script